import { isStaging, isDev } from 'common/utils/environment-util';
import _isEmpty from 'lodash/isEmpty';
import { STORAGE_USER_COUNTRY_CODE } from 'constants/app-constants';

export const redirectURL = link => {
  window.location.href = link;
};

// force user to login from GE Home Landing page if no country selected
// for local server, landing page is not available, hence skipped
// return [boolean] shouldRedirect
export const redirectToLandingPageIfNoCountry = () => {
  if (
    isDev() ||
    !_isEmpty(window.localStorage.getItem(STORAGE_USER_COUNTRY_CODE))
  ) {
    return false;
  }

  if (isStaging()) {
    redirectURL('https://express.stg-myteksi.com/');
    return true;
  }
  redirectURL('https://express.grab.com/');
  return true;
};

export default {};
